const fallbackFontFamily = `Arial, Helvetica, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol"`;

/**
 * For most body styles.
 */
export const interFontFamily = `"Inter", ${fallbackFontFamily}`;

export const interVarFontFamily = `"Inter var", ${fallbackFontFamily}`;

/**
 * An incorrectly-named font-family that we are using all over the place...
 * @deprecated Please use ttNormsVarFontFamily or ttNormsFontFamily.
 */
export const ttNormsProBoldFontFamily = `"TT Norms Pro Bold", ${fallbackFontFamily}`;

/**
 * For some headings and other text that needs to be a bit bolder.
 */
export const ttNormsFontFamily = `"TT Norms Pro", ${fallbackFontFamily}`;

export const ttNormsVarFontFamily = `"TT Norms Pro var", ${fallbackFontFamily}`;
